"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalRequestContext = exports.shouldConductByAccountByDefault = void 0;
var conduction_method_1 = require("../conduction-method");
function shouldConductByAccountByDefault(globalDefaults) {
    return (globalDefaults.conductionMethod === conduction_method_1.ConductionMethod.OwnerAccount &&
        globalDefaults.siteOwnerId &&
        globalDefaults.loggedInUserId);
}
exports.shouldConductByAccountByDefault = shouldConductByAccountByDefault;
function getGlobalRequestContext(globalDefaults) {
    if (shouldConductByAccountByDefault(globalDefaults)) {
        return {
            forSiteOwner: {
                siteOwnerId: globalDefaults.siteOwnerId,
                loggedInUserId: globalDefaults.loggedInUserId,
            },
        };
    }
    return {};
}
exports.getGlobalRequestContext = getGlobalRequestContext;
//# sourceMappingURL=global-defaults-checks.js.map